<template>
  <section>
    <form @submit.prevent="submitForm" class="m-form m-form--state">
      <div class="modal-body">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <div :class="[{'has-danger': errors.has('cam_name')}, 'col-lg-4']">
              <label for="name">{{'cam_name' | translate | capitalize }}</label>
              <input type="text" ref="cam_name" id="cam_name" v-model="camera_name" name="cam_name" :placeholder="'enter_cam_name' | translate | capitalize" class="form-control m-input" v-validate="'required'">
              <span v-show="errors.has('cam_name')" class="m-form__help m--font-danger"> {{errors.first('cam_name')}} </span>
            </div>
            <div :class="[{'has-danger': errors.has('cam_ip')}, 'col-lg-4']">
              <label for="name">{{'cam_ip' | translate | capitalize }}</label>
              <input type="text" ref="cam_ip" id="cam_ip" v-model="camera_ip" name="cam_ip" :placeholder="'enter_cam_ip' | translate | capitalize" class="form-control m-input" v-validate="'required|ip'">
              <span v-show="errors.has('cam_ip')" class="m-form__help m--font-danger"> {{errors.first('cam_ip')}} </span>
            </div>
            <div class="col-lg-4">
              <label for="manufacturer">{{ 'manufacturer' | translate | capitalize }}</label>
              <select v-model="manufacturer" name="manufacturer" id="manufacturer" class="form-control m_selectpicker" :title="'select_manufacture' | translate | capitalize">
                <option v-for="manu in manufacturers" :key="manu.id" :value="manu.id">{{ manu.name | translate | capitalize }}</option>
              </select>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div :class="[{'has-danger': errors.has('control_point')}, 'col-lg-4']">
              <label for="control_point">{{ 'control_point' | translate | capitalize }}</label>
              <select v-model="control_point" name="control_point" id="control_point" class="form-control m_selectpicker" v-validate="'required'" :title="'select_control_point' | translate | capitalize">
                <option v-for="cp in control_points" :key="cp.id" :value="cp.id">{{ cp.name | translate | capitalize }}</option>
              </select>
              <span v-show="errors.has('control_point')" class="m-form__help m--font-danger"> {{errors.first('control_point')}} </span>
            </div>
            <div class="col-lg-4">
              <label for="mode">{{ 'mode' | translate | capitalize }}</label>
              <select v-model="mode" name="mode" id="mode" class="form-control m_selectpicker" :title="'select_mode' | translate | capitalize">
                <option v-for="m in modes" :key="m.key" :value="m.name">{{ m.name | translate | capitalize }}</option>
              </select>
            </div>
            <div class="col-lg-4">
              <label for="reference">{{ 'reference' | translate | capitalize }}</label>
              <select v-model="reference" name="reference" id="reference" class="form-control m_selectpicker" :title="'select_reference' | translate | capitalize">
                <option v-for="rf in references" :key="rf.key" :value="rf.refer">{{ rf.refer }}</option>
              </select>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div :class="[{'has-danger': errors.has('user')}, 'col-lg-4']">
              <label for="name">{{'user' | translate | capitalize }}</label>
              <input type="text" ref="user" id="user" v-model="user" name="user" :placeholder="'enter_cam_user' | translate | capitalize" class="form-control m-input">
              <span v-show="errors.has('user')" class="m-form__help m--font-danger"> {{errors.first('user')}} </span>
            </div>
            <div :class="[{'has-danger': errors.has('password')}, 'col-lg-4']">
              <label for="password">{{'password' | translate | capitalize }}</label>
              <input type="password" ref="password" id="password" v-model="password" name="password" :placeholder="'enter_cam_password' | translate | capitalize" class="form-control m-input">
              <span v-show="errors.has('password')" class="m-form__help m--font-danger"> {{errors.first('password')}} </span>
            </div>
            <div class="col-lg-4">
              <label for="recognition_type">{{ 'recognition_type' | translate | capitalize }}</label>
              <select v-model="recognition_type" name="recognition_type" id="recognition_type" class="form-control m_selectpicker" :title="'select_license_plate_recognition_type' | translate | capitalize" v-validate="'required'">
                <option v-for="tf in recognition_types" :key="tf.key" :value="tf.key">{{ tf.type_rec | translate | capitalize }}</option>
              </select>
              <span v-show="errors.has('recognition_type')" class="m-form__help m--font-danger"> {{errors.first('recognition_type')}} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button v-on:click="reset()" type="button" class="btn btn-secondary" :data-dismiss="'modal'" id="btn-cancel-approve-camera">
          {{'close' | translate | capitalize }}
        </button>
        <button type="button" class="btn btn-primary-orange" @click="test_camera">
          {{'test' | translate | capitalize }}
        </button>
        <button type="submit" class="btn btn-primary" @submit.prevent="submitForm">
          {{'save' | translate | capitalize }}
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    data_send: Object
  },
  data () {
    return {
      control_point: '',
      control_points: [],
      camera_id: '',
      camera_name: '',
      camera_ip: '',
      edit: false,
      reference: '',
      references: [],
      recognition_type: '',
      recognition_types: [{key: 0, type_rec: 'Placa unica'}, {key: 1, type_rec: 'Doble validación'}, {key: 2, type_rec: 'Validación de credencial + fotografía'}],
      mode: '',
      modes: {},
      manufacturers: [],
      manufacturer: '',
      camera_status: '',
      picture: '',
      user: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters({ modal: 'getStatusCameraModal', permissions: 'getUserPermissions' })
  },
  methods: {
    ...mapActions(['retriveControlPoints', 'setStatusCameraModal', 'modifyCamera', 'addCamera', 'retrieveManufacturers', 'testNewCamera']),
    ...mapMutations(['updateStatusCameraModal']),
    submitForm () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            if (this.edit) {
              this.modify()
            } else {
              this.create()
            }
          }
        })
    },
    focusInput () {
      this.$refs.cam_name.focus()
    },
    modify () {
      var camera_data = {
        id: this.camera_id,
        name: this.camera_name,
        ip_address: this.camera_ip,
        manufacturer_id: this.manufacturer,
        control_point_id: this.control_point,
        reference: this.reference,
        mode: this.mode,
        user: this.user,
        password: this.password,
        recognition_type: this.recognition_type
      }
      this.$spinner.show()
      this.modifyCamera(camera_data)
        .then((res) => {
          this.$spinner.remove()
          if (res.status === 200) {
            this.$toast(res.data.message, 1)
            this.setStatusCameraModal(false)
            document.getElementById('btn-cancel-approve-camera').click()
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          document.getElementById('btn-cancel-approve-camera').click()
          this.$toast(res.data.message, 4)
          console.log(err)
        })
    },
    create () {
      var camera_data = {
        name: this.camera_name,
        ip_address: this.camera_ip,
        manufacturer_id: this.manufacturer,
        control_point_id: this.control_point,
        reference: this.reference,
        mode: this.mode,
        user: this.user,
        password: this.password,
        recognition_type: this.recognition_type
      }
      this.addCamera(camera_data)
        .then((res) => {
          this.$spinner.remove()
          if (res.status === 200) {
            this.$toast(res.data.message, 1)
            this.setStatusCameraModal(false)
            document.getElementById('btn-cancel-approve-camera').click()
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          document.getElementById('btn-cancel-approve-camera').click()
          this.$toast(res.data.message, 4)
          console.log(err)
        })
    },
    reset () {
      this.$validator.reset()
      this.setStatusCameraModal(false)
      this.edit = false
    },
    test_camera () {
      this.$spinner.show()
      let test_cam = { manufacturer_id: this.manufacturer, ip_address: this.camera_ip, user: this.user, password: this.password }
      this.testNewCamera(test_cam)
        .then((res) => {
          if (res.status === 200) {
            this.picture = 'data:image/png;base64,' + res.data
            this.$toast('on_camera_message')
            this.camera_status = 'on'
            this.$spinner.remove()
          }
        })
        .catch((err) => {
          this.$toast('off_camera_error', 4)
          this.$spinner.remove()
          this.camera_status = 'off'
          console.log(err)
        })
    }
  },
  created () {
    this.modes = [{key: 0, name: 'general_focus'}, {key: 1, name: 'face_recognition'}, {key: 2, name: 'plate_recognition'}]
    this.retriveControlPoints()
      .then((response) => {
        if (response.data) {
          this.control_points = response.data
        }
      })
      .catch((error) => {
        resolve(error)
      })
    this.retrieveManufacturers()
      .then((response) => {
        if (response.data) {
          this.manufacturers = response.data
        }
      })
      .catch((error) => {
        resolve(error)
      })
  },
  watch: {
    modal (newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.$nextTick(() => {
          if (this.data_send.id) {
            this.camera_name = this.data_send.name
            this.camera_ip = this.data_send.ip_address
            this.camera_id = this.data_send.id
            this.manufacturer = this.data_send.manufacturer_id
            this.control_point = this.data_send.control_point_id
            this.mode = this.data_send.mode
            this.reference = this.data_send.reference
            this.user = this.data_send.user
            this.password = this.data_send.password
            this.recognition_type = this.data_send.recognition_type
            this.edit = true
          } else {
            this.camera_name = ''
            this.camera_ip = ''
            this.camera_id = ''
            this.manufacturer = ''
            this.control_point = ''
            this.mode = ''
            this.reference = ''
            this.user = ''
            this.password = ''
            this.recognition_type = ''
            this.edit = false
            this.$validator.reset()
          }
        })
      }
    },
    control_point (newVal, oldVal) {
      let point = this.control_points.find(cp => cp.id === this.control_point)
      if (point) {
        this.references = [{key: 0, refer: point.reference_one}, {key: 1, refer: point.reference_two}]
      }
    }
  }
}
</script>

<style scope>
.center-custom{
  text-align: center !important;
  margin: 0 !important;
}

.btn-primary-orange {
  color: #ffffff;
  background-color: #da981a;
  border-radius: 0.25rem;
}

</style>


// WEBPACK FOOTER //
// NewCamera.vue